var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c(
          "div",
          {
            staticClass: "container",
            staticStyle: { padding: "24px 0 32px 0" }
          },
          [
            _c("div", { staticClass: "inner-container" }, [
              _c("div", { staticClass: "features-grid" }, [
                _c("div", { staticClass: "feature column" }, [
                  _c("span", { staticClass: "feature-box" }, [
                    _c("div", { staticClass: "icon-offset-new-property" }, [
                      _c("img", {
                        staticClass: "feature-icon",
                        attrs: {
                          loading: "lazy",
                          src: require("../../../static/img/brand-new-property-only.svg")
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-title margin-top22" }, [
                      _vm._v("Real Estate")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-title margin-top5" }, [
                      _vm._v("Built For You")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description mt-12" }, [
                      _vm._v(
                        "\n                Save time and money\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description" }, [
                      _vm._v(
                        "\n                by exploring land and\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description" }, [
                      _vm._v(
                        "\n                newly built homes for sale\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description" }, [
                      _vm._v(
                        "\n                that have never been lived in\n              "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "feature column-2" }, [
                  _c("span", { staticClass: "feature-box" }, [
                    _c("div", { staticClass: "icon-offset-buy-online" }, [
                      _c("img", {
                        staticClass: "feature-icon",
                        attrs: {
                          loading: "lazy",
                          src: require("../../../static/img/buy-online.svg")
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-title margin-top22" }, [
                      _vm._v("Enquire and")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-title margin-top5" }, [
                      _vm._v("Select Online")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description mt-12" }, [
                      _vm._v(
                        "\n                Contact the agent or\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description" }, [
                      _vm._v(
                        "\n                begin the buying process by\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description" }, [
                      _vm._v(
                        "\n                selecting your preferred\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description" }, [
                      _vm._v(
                        "\n                property online\n              "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "feature column-3" }, [
                  _c("span", { staticClass: "feature-box" }, [
                    _c("div", { staticClass: "icon-offset-price-list" }, [
                      _c("img", {
                        staticClass: "feature-icon",
                        attrs: {
                          loading: "lazy",
                          src: require("../../../static/img/live-pricelist.svg")
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-title margin-top22" }, [
                      _vm._v("Live Pricing with")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-title margin-top5" }, [
                      _vm._v("No Surprises")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description mt-12" }, [
                      _vm._v(
                        "\n                Pricing, availability and associated\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description" }, [
                      _vm._v(
                        "\n                fees are available for every project,\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description" }, [
                      _vm._v(
                        "\n                so you know the costs involved\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description" }, [
                      _vm._v(
                        "\n                with buying your next home\n              "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "feature column-4" }, [
                  _c("span", { staticClass: "feature-box" }, [
                    _c("div", { staticClass: "icon-offset-transparency" }, [
                      _c("img", {
                        staticClass: "feature-icon",
                        attrs: {
                          loading: "lazy",
                          src: require("../../../static/img/discover-with-transparency.svg")
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-title margin-top22" }, [
                      _vm._v("Explore Every")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-title margin-top5" }, [
                      _vm._v("Detail")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description mt-12" }, [
                      _vm._v(
                        "\n                With more real estate\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description" }, [
                      _vm._v(
                        "\n                information than any other platform,\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description" }, [
                      _vm._v(
                        "\n                you can analyse every aspect\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "feature-description" }, [
                      _vm._v(
                        "\n                before you decide\n              "
                      )
                    ])
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6877e19d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6877e19d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/agentSignInBox.vue
// module id = null
// module chunks = 